import Swiper from 'swiper';
import { Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';

const sliderHomeProducts = document.getElementById("home-slider");
if(sliderHomeProducts) {
    new Swiper(sliderHomeProducts, {
        lazy: true,
        modules: [Navigation, Autoplay],
        autoplay: {
            delay: 3000,
        },
        loop: true,
        grabCursor: true,
        slidesPerView: 1,
        spaceBetween: 0,
        navigation: {
            prevEl: '.swiper-button-prev',
            nextEl: '.swiper-button-next',
        },
    });
}